// extracted by mini-css-extract-plugin
export var socials__container = "Socials-module--socials__container--c125e";